import { useQuery } from '@tanstack/react-query'

import { usePageStateStore } from '@/reducers'
import { fetchLimits } from '@/utils/limits'

export const useLimitsQuery = () => {
  const authToken = usePageStateStore.use.authToken()

  return useQuery({
    queryKey: ['limits', authToken],
    queryFn: fetchLimits,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}

export const useLimits = () => useLimitsQuery().data ?? null
